import { Component, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidatorFn, ValidationErrors } from '@angular/forms';
import { Router } from '@angular/router';
import { AccountService } from 'src/app/services/account.service';
import { CoreService } from 'src/app/services/core.service';
import { AuthService } from '../auth.service';
import { RenewExpiredPasswordService } from './renew-expired-password.service';

@Component({
  selector: 'renew-expired-password',
  templateUrl: './renew-expired-password.component.html',
  styleUrls: ['./renew-expired-password.component.scss']
})
export class RenewExpiredPasswordComponent {
    @Output() onResult = new EventEmitter<boolean>();
    accessToken: string;
    loading = false;
    errorText: string | null = null;
    form = new FormGroup({
        NewPassword: new FormControl(null, [Validators.required]),
        ConfirmPassword: new FormControl(null, [Validators.required]),
    }, { validators: this._checkPasswords as ValidatorFn });

    constructor(
        private renewExpiredPasswordService: RenewExpiredPasswordService
    ) {}

    get f() {
        return this.form.controls;
    }

    async submit() {
        if (this.form.invalid) { return; }
        
        this.errorText = null;
        this.loading = true;
        this.form.disable();
        try {
            await this.renewExpiredPasswordService.doRenewExpiredPassword(this.accessToken, this.f.NewPassword.value!, this.f.ConfirmPassword.value!);
            this.onResult.emit(true);
        } catch(e: any) {
            this.errorText = e;
            this.loading = false;
            this.form.enable();
        }
    }

    exitScreen() {
        this.onResult.emit(false);
    }

    private _checkPasswords(group: FormGroup): ValidationErrors | null {
        const password = group.get('NewPassword')!.value;
        const confirmPassword = group.get('ConfirmPassword')!.value;
        if (
            password !== confirmPassword && (
                (group.get('NewPassword')!.touched || group.get('NewPassword')!.dirty) && 
                (group.get('ConfirmPassword')!.touched || group.get('ConfirmPassword')!.dirty)
            )) {
            return { PasswordNotSame: true };
        }
        return null;
    }
}